import { useMutation } from "@apollo/client/react";
import {
  CreateMultipleChoiceInFolder,
  CreateMultipleChoiceInFolderInput,
  CreateMultipleChoiceInFolderVariables,
  MultipleChoiceType,
} from "__generated__/types";
import { MultipleChoiceCreateForm } from "domain/admin/multiple-choice/MultipleChoiceCreateForm";
import gql from "graphql-tag";
import React from "react";

const MUTATION = gql`
  mutation CreateMultipleChoiceInFolder(
    $input: CreateMultipleChoiceInFolderInput!
  ) {
    createMultipleChoiceInFolder(input: $input) {
      folderMultipleChoice {
        id
      }
    }
  }
`;

interface Props {
  folderId: string;
  type: MultipleChoiceType;
  cancel(): void;
  complete(): void;
}

export const FolderMultipleChoiceCreateForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ folderId, type, cancel, complete }) => {
  const [mutate, { loading, error }] = useMutation<
    CreateMultipleChoiceInFolder,
    CreateMultipleChoiceInFolderVariables
  >(MUTATION);

  const onSubmit = async (
    data: CreateMultipleChoiceInFolderInput["multipleChoice"],
  ) => {
    const result = await mutate({
      variables: {
        input: {
          folderId,
          multipleChoice: {
            title: data.title,
            type: type,
          },
        },
      },
    });

    return !!result.data;
  };

  return (
    <MultipleChoiceCreateForm
      mutate={onSubmit}
      loading={loading}
      error={error}
      cancel={cancel}
      complete={complete}
    />
  );
};
